import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import HelpArticleLink from '../../../../components/help-article-link';
import { SimpleModal } from '../../../../components/simple-modal';
import { linkIDs } from '../../../../services/link-service/links';
import { pages } from '../../nav-items';

import messages from './messages';
import style from './style.module.less';

const automationRulesPath = `/${pages.settings.location}/${pages.automationRules.location}`;

export const AutomationRulesModal = ({ marketplaceName, onClose }) => {
  const history = useHistory();

  const navigateToAutomationRules = useCallback(() => {
    onClose();
    history.push(automationRulesPath);
  }, [history, onClose]);

  return (
    <SimpleModal
      actionMessage={messages.createAutomationButton}
      cancelMessage={messages.doneButton}
      headerMessage={messages.modalHeader}
      onAction={navigateToAutomationRules}
      onCancel={onClose}
      onClose={onClose}
      size='medium'
    >
      <>
        <div className={style['modal-body-text']} data-testId={marketplaceName}>
          <FormattedMessage {...messages.marketplaceConnectionConfirmation} values={{ marketplaceName }} />
        </div>
        <div className={style['modal-body-text']}>
          <FormattedMessage {...messages.automationRulesTip} values={{ marketplaceName }} />
        </div>
        <div className={style['modal-body-text']}>
          <FormattedMessage
            {...messages.kbArticleLink}
            values={{
              l: (chunks) => <HelpArticleLink articleId={linkIDs.DelegateOrdersFulfillmentProviders}>{chunks}</HelpArticleLink>,
            }}
          />
        </div>
      </>
    </SimpleModal>
  );
};

AutomationRulesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  marketplaceName: PropTypes.string.isRequired,
};
